import $ from 'jquery'
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.css'

import { SfTime } from '@app/adapters/time'

const targetFormat = (target) => {
  return (
    target.dataset.momentJsFormat || target.dataset.dateFormat.toUpperCase()
  )
}

const parseDate = (target, date) => {
  if (!date || !date.trim()) return

  const momentDate = SfTime(date, targetFormat(target))
  if (!momentDate.isValid()) return

  return momentDate.toDate()
}

const formatDate = (target, date) => SfTime(date).format(targetFormat(target))

onDomLoad(function () {
  $(document).on(
    'click focus',
    '[data-behaviour~="markdown-datepicker"]',
    (event) => {
      const target = event.target

      if (!target._flatpickr) {
        flatpickr(target, {
          position: 'below left',
          allowInput: true,
          formatDate: (date) => formatDate(target, date),
          parseDate: (date) => parseDate(target, date),
        })
      }
    }
  )
})
